// This file is auto-generated by @hey-api/openapi-ts

import type { Options as ClientOptions, TDataShape, Client } from './client'
import type {
  GetBeaconData,
  GetBeaconResponses,
  PutBeaconData,
  PutBeaconResponses,
  GetGpsData,
  GetGpsResponses,
  PutGpsData,
  PutGpsResponses,
  PostGpsRestartData,
  PostGpsRestartResponses,
  GetIrCutFilterData,
  GetIrCutFilterResponses,
  PutIrCutFilterData,
  PutIrCutFilterResponses,
  GetIrLightData,
  GetIrLightResponses,
  PutIrLightAbsoluteData,
  PutIrLightAbsoluteResponses,
  PostIrLightRelativeData,
  PostIrLightRelativeResponses,
  GetZoomData,
  GetZoomResponses,
  PutZoomAbsoluteData,
  PutZoomAbsoluteResponses,
  PostZoomRelativeData,
  PostZoomRelativeResponses,
  PutZoomResetData,
  PutZoomResetResponses,
  GetFocusData,
  GetFocusResponses,
  PutFocusAbsoluteData,
  PutFocusAbsoluteResponses,
  PostFocusRelativeData,
  PostFocusRelativeResponses,
  PutFocusResetData,
  PutFocusResetResponses,
  GetApertureData,
  GetApertureResponses,
  PutApertureAbsoluteData,
  PutApertureAbsoluteResponses,
  PostApertureRelativeData,
  PostApertureRelativeResponses,
  PutApertureResetData,
  PutApertureResetResponses,
  GetCameraData,
  GetCameraResponses,
  PutCameraData,
  PutCameraResponses,
  RestartCameraData,
  RestartCameraResponses,
  GetCamera3dData,
  GetCamera3dResponses,
  PutCamera3dData,
  PutCamera3dResponses,
  RestartCamera3dData,
  RestartCamera3dResponses,
  GetEngineData,
  GetEngineResponses,
  PutHeartbeatData,
  PutHeartbeatResponses,
  GetServerData,
  GetServerResponses,
  PostServerShutdownData,
  PostServerShutdownResponses,
  PostServerForceShutdownData,
  PostServerForceShutdownResponses,
  PostServerRestartData,
  PostServerRestartResponses,
  PostServerForceRestartData,
  PostServerForceRestartResponses,
  PostRoofShutdownData,
  PostRoofShutdownResponses,
  PostRoofForceShutdownData,
  PostRoofForceShutdownResponses,
  PostRoofRestartData,
  PostRoofRestartResponses,
  PostRoofForceRestartData,
  PostRoofForceRestartResponses,
} from './types.gen'
import { client as _heyApiClient } from './@tanstack/initializer'

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<
  TData,
  ThrowOnError
> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>
}

/**
 * Beacon state getter
 */
export const getBeacon = <ThrowOnError extends boolean = false>(options?: Options<GetBeaconData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<GetBeaconResponses, unknown, ThrowOnError>({
    url: '/beacon',
    ...options,
  })
}

/**
 * Beacon state setter
 */
export const putBeacon = <ThrowOnError extends boolean = false>(options: Options<PutBeaconData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<PutBeaconResponses, unknown, ThrowOnError>({
    url: '/beacon',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * GPS state getter
 */
export const getGps = <ThrowOnError extends boolean = false>(options?: Options<GetGpsData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<GetGpsResponses, unknown, ThrowOnError>({
    url: '/gps',
    ...options,
  })
}

/**
 * GPS state setter
 */
export const putGps = <ThrowOnError extends boolean = false>(options: Options<PutGpsData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<PutGpsResponses, unknown, ThrowOnError>({
    url: '/gps',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * GPS restart
 */
export const postGpsRestart = <ThrowOnError extends boolean = false>(
  options?: Options<PostGpsRestartData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<PostGpsRestartResponses, unknown, ThrowOnError>({
    url: '/gps/restart',
    ...options,
  })
}

/**
 * IR-Cut Filter getter
 */
export const getIrCutFilter = <ThrowOnError extends boolean = false>(
  options: Options<GetIrCutFilterData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<GetIrCutFilterResponses, unknown, ThrowOnError>({
    url: '/ir-cut-filter/{camera_position}',
    ...options,
  })
}

/**
 * IR-Cut Filter setter
 */
export const putIrCutFilter = <ThrowOnError extends boolean = false>(
  options: Options<PutIrCutFilterData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<PutIrCutFilterResponses, unknown, ThrowOnError>({
    url: '/ir-cut-filter/{camera_position}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * IR Light level getter
 */
export const getIrLight = <ThrowOnError extends boolean = false>(options: Options<GetIrLightData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<GetIrLightResponses, unknown, ThrowOnError>({
    url: '/ir-light/{ir_light_position}',
    ...options,
  })
}

/**
 * IR Light absolute level setter
 */
export const putIrLightAbsolute = <ThrowOnError extends boolean = false>(
  options: Options<PutIrLightAbsoluteData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<PutIrLightAbsoluteResponses, unknown, ThrowOnError>({
    url: '/ir-light/absolute/{ir_light_position}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * IR Light relative level setter
 */
export const postIrLightRelative = <ThrowOnError extends boolean = false>(
  options: Options<PostIrLightRelativeData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<PostIrLightRelativeResponses, unknown, ThrowOnError>({
    url: '/ir-light/relative/{ir_light_position}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Zoom level getter
 */
export const getZoom = <ThrowOnError extends boolean = false>(options: Options<GetZoomData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<GetZoomResponses, unknown, ThrowOnError>({
    url: '/zoom/{camera_position}',
    ...options,
  })
}

/**
 * Zoom absolute level setter
 */
export const putZoomAbsolute = <ThrowOnError extends boolean = false>(
  options: Options<PutZoomAbsoluteData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<PutZoomAbsoluteResponses, unknown, ThrowOnError>({
    url: '/zoom/absolute/{camera_position}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Zoom relative level setter
 */
export const postZoomRelative = <ThrowOnError extends boolean = false>(
  options: Options<PostZoomRelativeData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<PostZoomRelativeResponses, unknown, ThrowOnError>({
    url: '/zoom/relative/{camera_position}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Reset zoom to zero (ignoring bounds)
 */
export const putZoomReset = <ThrowOnError extends boolean = false>(
  options: Options<PutZoomResetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<PutZoomResetResponses, unknown, ThrowOnError>({
    url: '/zoom/reset/{camera_position}',
    ...options,
  })
}

/**
 * Focus getter
 */
export const getFocus = <ThrowOnError extends boolean = false>(options: Options<GetFocusData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<GetFocusResponses, unknown, ThrowOnError>({
    url: '/focus/{camera_position}',
    ...options,
  })
}

/**
 * Focus absolute level setter
 */
export const putFocusAbsolute = <ThrowOnError extends boolean = false>(
  options: Options<PutFocusAbsoluteData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<PutFocusAbsoluteResponses, unknown, ThrowOnError>({
    url: '/focus/absolute/{camera_position}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Focus relative level setter
 */
export const postFocusRelative = <ThrowOnError extends boolean = false>(
  options: Options<PostFocusRelativeData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<PostFocusRelativeResponses, unknown, ThrowOnError>({
    url: '/focus/relative/{camera_position}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Reset focus to zero (ignoring bounds)
 */
export const putFocusReset = <ThrowOnError extends boolean = false>(
  options: Options<PutFocusResetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<PutFocusResetResponses, unknown, ThrowOnError>({
    url: '/focus/reset/{camera_position}',
    ...options,
  })
}

/**
 * Aperture getter
 */
export const getAperture = <ThrowOnError extends boolean = false>(options: Options<GetApertureData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<GetApertureResponses, unknown, ThrowOnError>({
    url: '/aperture/{camera_position}',
    ...options,
  })
}

/**
 * Aperture absolute level setter
 */
export const putApertureAbsolute = <ThrowOnError extends boolean = false>(
  options: Options<PutApertureAbsoluteData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<PutApertureAbsoluteResponses, unknown, ThrowOnError>({
    url: '/aperture/absolute/{camera_position}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Aperture relative level setter
 */
export const postApertureRelative = <ThrowOnError extends boolean = false>(
  options: Options<PostApertureRelativeData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<PostApertureRelativeResponses, unknown, ThrowOnError>({
    url: '/aperture/relative/{camera_position}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Reset aperture to zero (ignoring bounds)
 */
export const putApertureReset = <ThrowOnError extends boolean = false>(
  options: Options<PutApertureResetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<PutApertureResetResponses, unknown, ThrowOnError>({
    url: '/aperture/reset/{camera_position}',
    ...options,
  })
}

/**
 * Camera getter
 */
export const getCamera = <ThrowOnError extends boolean = false>(options: Options<GetCameraData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<GetCameraResponses, unknown, ThrowOnError>({
    url: '/camera/{camera_position}',
    ...options,
  })
}

/**
 * Camera setter
 */
export const putCamera = <ThrowOnError extends boolean = false>(options: Options<PutCameraData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<PutCameraResponses, unknown, ThrowOnError>({
    url: '/camera/{camera_position}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Camera restart
 */
export const restartCamera = <ThrowOnError extends boolean = false>(
  options: Options<RestartCameraData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<RestartCameraResponses, unknown, ThrowOnError>({
    url: '/camera/{camera_position}/restart',
    ...options,
  })
}

/**
 * 3D Camera getter
 */
export const getCamera3D = <ThrowOnError extends boolean = false>(options: Options<GetCamera3dData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<GetCamera3dResponses, unknown, ThrowOnError>({
    url: '/camera3d/{camera_position}',
    ...options,
  })
}

/**
 * 3D Camera setter
 */
export const putCamera3D = <ThrowOnError extends boolean = false>(options: Options<PutCamera3dData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<PutCamera3dResponses, unknown, ThrowOnError>({
    url: '/camera3d/{camera_position}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * 3D Camera restart
 */
export const restartCamera3D = <ThrowOnError extends boolean = false>(
  options: Options<RestartCamera3dData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<RestartCamera3dResponses, unknown, ThrowOnError>({
    url: '/camera3d/{camera_position}/restart',
    ...options,
  })
}

/**
 * Engine state getter
 */
export const getEngine = <ThrowOnError extends boolean = false>(options?: Options<GetEngineData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<GetEngineResponses, unknown, ThrowOnError>({
    url: '/engine',
    ...options,
  })
}

/**
 * Endpoint to listen for heartbeat of our services
 */
export const putHeartbeat = <ThrowOnError extends boolean = false>(
  options?: Options<PutHeartbeatData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<PutHeartbeatResponses, unknown, ThrowOnError>({
    url: '/heartbeat',
    ...options,
  })
}

/**
 * Server state getter
 */
export const getServer = <ThrowOnError extends boolean = false>(options?: Options<GetServerData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<GetServerResponses, unknown, ThrowOnError>({
    url: '/server',
    ...options,
  })
}

/**
 * Server shutdown
 */
export const postServerShutdown = <ThrowOnError extends boolean = false>(
  options?: Options<PostServerShutdownData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<PostServerShutdownResponses, unknown, ThrowOnError>({
    url: '/server/shutdown',
    ...options,
  })
}

/**
 * Force server shutdown
 */
export const postServerForceShutdown = <ThrowOnError extends boolean = false>(
  options?: Options<PostServerForceShutdownData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<PostServerForceShutdownResponses, unknown, ThrowOnError>({
    url: '/server/force-shutdown',
    ...options,
  })
}

/**
 * Server restart
 */
export const postServerRestart = <ThrowOnError extends boolean = false>(
  options?: Options<PostServerRestartData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<PostServerRestartResponses, unknown, ThrowOnError>({
    url: '/server/reset',
    ...options,
  })
}

/**
 * Force server restart
 */
export const postServerForceRestart = <ThrowOnError extends boolean = false>(
  options?: Options<PostServerForceRestartData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<PostServerForceRestartResponses, unknown, ThrowOnError>({
    url: '/server/force-reset',
    ...options,
  })
}

/**
 * Roof shutdown
 */
export const postRoofShutdown = <ThrowOnError extends boolean = false>(
  options?: Options<PostRoofShutdownData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<PostRoofShutdownResponses, unknown, ThrowOnError>({
    url: '/roof/shutdown',
    ...options,
  })
}

/**
 * Force roof shutdown
 */
export const postRoofForceShutdown = <ThrowOnError extends boolean = false>(
  options?: Options<PostRoofForceShutdownData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<PostRoofForceShutdownResponses, unknown, ThrowOnError>({
    url: '/roof/force-shutdown',
    ...options,
  })
}

/**
 * Roof restart
 */
export const postRoofRestart = <ThrowOnError extends boolean = false>(
  options?: Options<PostRoofRestartData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<PostRoofRestartResponses, unknown, ThrowOnError>({
    url: '/roof/reset',
    ...options,
  })
}

/**
 * Force roof restart
 */
export const postRoofForceRestart = <ThrowOnError extends boolean = false>(
  options?: Options<PostRoofForceRestartData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<PostRoofForceRestartResponses, unknown, ThrowOnError>({
    url: '/roof/force-reset',
    ...options,
  })
}
